import PdfViewer from '@/components/medico/pdf-viewer/index.vue'

export default {
  name: 'ExamDetailsPreviewDocuments',
  props: {
    details: {
      type: Object
    },
    pdfUrl: {
      type: String,
      default: ''
    }
  },
  components: {
    PdfViewer
  },
  methods: {
    convertDate(date) {
      return new Date(date).toLocaleString()
    }
  }
}
